module.exports = __webpack_public_path__ + "img/idCard-front.590dd5e3.png";